import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import MenuItem from '@material-ui/core/MenuItem';
import { green } from '@material-ui/core/colors';
import { AddOffer, GetOffer, EditOffer } from '../../fetchs';
import DatePicker from 'react-datepicker2';

import './offer.styles.css';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 650,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    width: 600,
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
});

class Offer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gregorianValidFrom: null,
      gregorianValidTo: null,
      offerType: 1,
      value: 0,
      validCount: 0,
      loading: false,
      saving: false
    }
  }

  componentDidMount() {
    const offerId = this.props.match.params.offerId;
    if (offerId) {
      this.loadOffer(offerId);
    }
  }

  loadOffer = (offerId) => {
    this.setState({ loading: true });
    GetOffer(offerId)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          offerId: responseJson.offerId,
          offerType: responseJson.offerType,
          gregorianValidFrom: responseJson.gregorianValidFrom,
          gregorianValidTo: responseJson.gregorianValidTo,
          value: responseJson.value,
          validCount: responseJson.validCount
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  handleSave = () => {
    if (this.props.match.params.offerId) {
      EditOffer(this.state.offerId, {
        gregorianValidFrom: this.state.gregorianValidFrom,
        gregorianValidTo: this.state.gregorianValidTo,
        offerType: this.state.offerType,
        value: this.state.value,
        validCount: this.state.validCount
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/offers');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    } else {
      AddOffer({
        gregorianValidFrom: this.state.gregorianValidFrom,
        gregorianValidTo: this.state.gregorianValidTo,
        offerType: this.state.offerType,
        value: this.state.value,
        validCount: this.state.validCount
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/offers');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleCheckChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              افزودن تخفیف جدید
            </Typography>
            <Grid container>
              <Grid item md={7}>
                <React.Fragment>
                  <form className={classes.container} noValidate autoComplete="off">
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <div className="MuiFormControl-root MuiTextField-root MuiFormControl-marginNormal MuiFormControl-fullWidth">
                          <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"
                            data-shrink="true" htmlFor="standard-from-date">از</label>
                          <DatePicker
                            id="standard-from-date"
                            onChange={value => this.setState({ gregorianValidFrom: value })}
                            value={this.state.gregorianValidFrom}
                            isGregorian={false}
                            fullWidth
                            className="textField"
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div className="MuiFormControl-root MuiTextField-root MuiFormControl-marginNormal MuiFormControl-fullWidth">
                          <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"
                            data-shrink="true" htmlFor="standard-to-date">تا</label>
                          <DatePicker
                            id="standard-to-date"
                            onChange={value => this.setState({ gregorianValidTo: value })}
                            value={this.state.gregorianValidTo}
                            isGregorian={false}
                            fullWidth
                            className="textField"
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-select-offer-type"
                          select
                          label="نوع تخفیف"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.offerType}
                          onChange={this.handleChange('offerType')}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin="normal"
                        >
                          <MenuItem value={1}>
                            درصد
                          </MenuItem>
                          <MenuItem value={2}>
                            مقدار
                          </MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-value"
                          label="مقدار"
                          required
                          type="number"
                          fullWidth
                          className={classes.textField}
                          value={this.state.value}
                          onChange={this.handleChange('value')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-valid-count"
                          label="تعداد دفعات مجاز استفاده"
                          type="number"
                          fullWidth
                          className={classes.textField}
                          value={this.state.validCount}
                          onChange={this.handleChange('validCount')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          disabled={this.state.loading}
                          onClick={this.handleSave}>ذخیره</Button>
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

Offer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Offer));
